import { useMemo } from 'react';
import { createClient, CreateClientOptions } from './graphqlClient';
import { useQueryCache } from './QueryCacheProvider';

export function useClient(options: Omit<CreateClientOptions, 'initialCache'>) {
  const cache = useQueryCache();
  return useMemo(() => {
    const client = createClient({ ...options, initialCache: cache });
    return client;
  }, [options, cache]);
}
